<template>
  <div>
    <ProgramQuestionCreate
      v-if="detailStatus"
      :detailTaskId="detailTaskId"
      :editing.sync="editing"
      :questionDetail="questionDetail"
      @editing="handleEdit"
      :type.sync="type"
    >
      <QuestionContent
        slot="program-code"
        v-if="detailStatus"
        style="padding-top:30px"
        :questionForm="questionDetail"
        :channel="type"
      ></QuestionContent>
    </ProgramQuestionCreate>
  </div>
</template>

<script>
import ProgramQuestionCreate from "./ProgramQuestionCreate.vue";
import codeService from "@/global/service/code";
import QuestionContent from "./widgets/QuestionContent.vue";

export default {
  components: {
    ProgramQuestionCreate,
    QuestionContent
  },
  data() {
    return {
      detailTaskId: null,
      type: "detail",
      editing: false,
      detailStatus: false,
      questionDetail: {
        question_type: 1, // 题目类型：1 编程题；2 绘图题；3 简答题
        examPointArr: [],
        score: null,
        level: 1, // 难易等级：1 简单；2 普通；3 困难
        source: 6,
        timeMax: null,
        spaceMax: null,
        programmingLanguage: [],
        languages: [
          {
            lang: "zh",
            label: "中文",
            title: "",
            stem: "",
            analysis: ""
          },
          {
            lang: "en",
            label: "英文",
            title: "",
            stem: "",
            analysis: ""
          },
          {
            lang: "fr",
            label: "法文",
            title: "",
            stem: "",
            analysis: ""
          }
        ],
        program: {},
        autoJudge: 1,
        caseList: []
      }
    };
  },
  created() {
    if (this.$route.query.source) {
      this.editing = true;
      this.type = "create";
    }
    this.getData();
  },
  methods: {
    getData() {
      codeService
        .programDetail(this.$route.params.uuid)
        .then(res => {
          this.detailTaskId = res.question_task_id;
          this.detailStatus =
            typeof this.detailTaskId == "number" ? true : false;
          const time_type = res.answer_time % 60 === 0 ? 1 : 2;
          const answer_time =
            time_type === 1 ? res.answer_time / 60 : res.answer_time;
          const examPointArr = res.exam_tags.map(tag => tag.name);
          const {
            score,
            level,
            source,
            test_cases: caseList,
            is_auto_judge: autoJudge,
            limit_time: timeMax,
            limit_memory: spaceMax,
            type: question_type,
            program_languages: programmingLanguage,
            output,
            status,
            common_industries,
            stacks,
            verity_logs
          } = res;
          res.contents.map(content => {
            this.questionDetail.languages.find(lan => {
              if (lan.lang == content.lang) {
                lan.title = content.title;
                lan.id = content.id;
                lan.stem = content.description;
                lan.analysis = content.analysis;
              }
            });
          });
          const program = {};
          const example = {};
          res.program_languages.map(item => {
            program[item.name] = item.code ? item.code : "";
            example[item.name] = item.sample_code ? item.sample_code : "";
          });
          this.questionDetail = {
            ...this.questionDetail,
            score,
            level,
            source,
            caseList,
            examPointArr,
            autoJudge,
            timeMax,
            spaceMax,
            question_type,
            programmingLanguage,
            program,
            output,
            answer_time,
            time_type,
            example,
            status,
            common_industries: common_industries.map(item => item.id),
            id: res.id,
            stacks,
            verity_logs:
              verity_logs.length > 0
                ? verity_logs[0].reason + verity_logs[0].description
                : null
          };
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleEdit(val) {
      this.editing = val;
      if (!this.editing) {
        this.getData();
      }
    }
  }
};
</script>

<style></style>
